import React, { useEffect } from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { theme } from "../theme";
import { Helmet } from "react-helmet";
import QR from '../Auditions/QR.png'
import { set } from "react-ga";
// import "./auditions.css";

const Auditions = ({ type }) => {
  //const [value, setValue] = React.useState(0);
  const [see, setSee] = React.useState(false);
  const [show, setShow] = React.useState(true);
  useEffect(() => {
    if (localStorage.getItem('visited')) {
      setShow(true)
      setSee(false)
      console.log('hello')
      setTimeout(() => {
        setShow(false)
      }, 3000);
      
    }
    else {
      localStorage.setItem('visited', true);
      
      setShow(false)
    }
  }, []);
  
  return (
    <MuiThemeProvider theme={theme}>
      <div className="curtain">
        <div></div>
      </div> 
      <br />
      <br />

      <Helmet>
        <title>Aura Auditions || 2022-23 </title>
        <meta
          name="description"
          content="Registration page for the auditions of the dramatics and film making team of DJ Sanghvi College of Engineering"
        />
      </Helmet>
      <div
        id="auditions"
        className="content-wrapper"
        style={{ padding: "0" }}
      >
        {
          show ?
            <>
              <lottie-player src='https://assets2.lottiefiles.com/packages/lf20_5upjwxvm.json'
                background="transparent" speed="1" class='done-party' autoplay></lottie-player>
              <lottie-player src='https://assets7.lottiefiles.com/packages/lf20_REOnx3.json'
                background="transparent" speed="1" class='done-party' autoplay></lottie-player>
            </>
            :
            <>
            </>
        }
        {
          see ?
            <>
              {/*<Typography variant="h3" className="head-description fadeInUp ">
                Aura <span className='golden' id="nobold">Auditions</span>
              </Typography>
              <br />
              <p className="welcome-team-head-2">
                You've heard of us, and we want you!
                Aura is, in the most open-ended sense, a bunch of storytellers who want to express what they have in them, through various mediums.
                This year, we're looking for dedicated and creative individuals who have the fire to express themselves.
                We're gonna be recruiting Actors, Writers, Editors, Directors, Graphic and Sound designers.
                With our vision constantly expanding, our requirement for passionate storytellers is also ever expanding.<br/>
                Join us, to be a part of a group of diverse and creative individuals, who create together, learn together and grow together!<br/><br/>
                Click on the <span><a href='https://forms.gle/yDyjLoS1PXmGkWhGA'>Registration Link</a></span> or scan the QR Code to Register..! <span className="QRspan" ><img className="QR" src={QR} alt="QR"></img></span>
              </p>
              <div className="content-wrapper-auditions">
                
              </div>
              */}
            </>
            :
            <>
              <Typography variant="h3" className="head-description fadeInUp ">
                Registrations <span className='golden' id="nobold">Closed</span>
              </Typography>
              <br />
              {/*<div className='guidelines' onClick={() => {setSee(true);setShow(false)}}>
                <p>Register</p>
              </div>*/}
              <p className="welcome-team-head-2">
              Thank you so much for registering for the auditions, we can't wait to see y'all perform 🔥🔥 and we hope you're just as excited as us 😉.
              The exact details regarding the auditions will be revealed soon, till then, y'all can check us out on our Social Media Handles and see what Aura is all about so y'all can prepare better.
              All the best and break a leg. 🙌
              </p>
              
              
            </>
            
        }
      </div>
    </MuiThemeProvider>
  );
};

export default Auditions;
